import { Box, CardMedia, Grid, Typography } from '@mui/material';
import React from 'react';
import trustBannerImg from '../../../images/trust-banner.png';
import bannerBg from '../../../images/Pattern.png';
import '../../WhyTrustUs/TrustUsBanner/TrustUsBanner.css';

const imageRightBg = {
    backgroundImage: `url(${bannerBg})`,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat',
    paddingBottom: '9%'
}

const OurWorkBanner = () => {
    return (
        <Box sx={{ pt: 2, pb: 8 }}>
            <Grid container sx={{ pt: { xs: 4 } }}>
                <Grid item xs={5} sx={{ pt: { xs: 3 } }}>
                    <Box className="home-about-container">
                        <Box sx={{ position: 'relative', pl: { xs: 2.375, sm: 4, md: 3, lg: 6, xl: 10 } }}>
                            <Box sx={{ textAlign: 'left', pt: { xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }, mb: { xs: 5, md: 10, lg: 15, xl: 20 } }}>
                                <Typography
                                    sx={{ fontWeight: 500, fontSize: { xs: 15, sm: 26, md: 38, lg: 40, xl: 45 }, color: '#000D83', textAlign: 'left', pl: { xs: 2, sm: 3, md: 3, lg: 3, xl: 3 }, pb: { sm: 3.5, md: 4 }, pt: { xs: 1.7, sm: 3, md: 4 } }}
                                    variant="h1"
                                    component="div"
                                    className="about-title"
                                >Why Work<br />With Us</Typography>
                            </Box>

                            <Box sx={{ pt: { sm: 1.5, md: 2, xl: 4 }, pr: { xs: 2.125, md: 3, xl: 6 }, pl: { xs: 2.375, md: 4.5, xl: 5.5 }, pb: { xs: 1.875, md: 2.8, xl: 4 }, position: 'absolute', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
                                style={{ zIndex: 2, backdropFilter: ' blur(7px)' }} id="banner-border-1">
                                <Typography
                                    sx={{ display: { xs: 'none', sm: 'block' }, fontWeight: 400, fontSize: { sm: 15, md: 18, lg: 20, xl: 23 }, lineHeight: { sm: '24px', md: '26px', lg: '33px' }, color: '#454545', textAlign: 'left', pb: 1 }}
                                    variant="h3"
                                    noWrap
                                    component="div"
                                >
                                    <span style={{ color: '#000D83', fontWeight: 500 }}>Lorem ipsum</span> dolor sit amet, consectetur adipiscing Amet <br /> pharetra, maecena. consectetur adipiscing Amet pharetra, <br /> maecena. Lorem ipsum dolor sit amet, consectetur <br /> adipiscing Amet pharetra, maecena.
                                </Typography>
                                {/* For Mobile Device */}
                                <Typography
                                    sx={{ display: { sm: 'none', textAlign: 'left' }, pt: { xs: 2 }, fontWeight: 400, fontSize: 10, lineHeight: '16px', color: '#454545' }}
                                    variant="h3"
                                    noWrap
                                    component="div"
                                >
                                    <span style={{ color: '#000D83', fontWeight: 500 }}>Lorem ipsum</span> dolor sit amet, consectetur adipiscing Amet<br />pharetra, maecena. consectetur adipiscing Amet pharetra,<br />maecena. Lorem ipsum dolor sit amet, consectetur<br />adipiscing Amet pharetra, maecena.
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={7} sx={{ pt: { xs: 2, sm: 0 } }}>
                    <Box style={imageRightBg}>
                        <CardMedia
                            component="img"
                            sx={{ width: '100%' }}
                            style={{ zIndex: 1 }}
                            image={trustBannerImg}
                            alt=""
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box >
    );
};

export default OurWorkBanner;